import { logout } from 'src/store/auth/authSlice';
import { AppDispatch } from '@helpers/store';
import { resetPreferencesState } from 'src/store/preferences/preferencesSlice';

export const authLogout = () => (dispatch: AppDispatch) => {
  dispatch(resetPreferencesState());
  dispatch(logout());
};
